export const SAVE_DATA_ENTRY = "@@checkers/SAVE_DATA_ENTRY";
export const LOAD_DATA_ENTRY_INTO_STORE = "@@checkers/LOAD_DATA_ENTRY_INTO_STORE";
export const LOAD_COUNTIES_INTO_STORE = "@@checkers/LOAD_COUNTIES_INTO_STORE";
export const LOAD_REPORT_TYPES_INTO_STORE = "@@checkers/LOAD_REPORT_TYPES_INTO_STORE";
export const SEARCH_REPORTS = "@@checkers/SEARCH_REPORTS";
export const SEARCH_REPORTS_PAGED = "@@checkers/SEARCH_REPORTS_PAGED";
export const OPEN_REPORT = "@@checkers/OPEN_REPORT";
export const ASSIGN_AND_OPEN_REPORT = "@@checkers/ASSIGN_AND_OPEN_REPORT";
export const UNASSIGN = "@@checkers/UNASSIGN";
export const SAVE_CHECKERS = "@@checkers/COMPLETE_PAPER_DATA_ENTRY";
export const REMOVE_FROM_RESULTS = "@@checkers/REMOVE_FROM_RESULTS";
export const GET_IMAGE = "@@checkers/GET_IMAGE";
export const GET_FORM_40 = "@@checkers/GET_FORM_40";
export const GET_FRONTSHEET = "@@checkers/GET_FRONTSHEET";
export const COMPLETE_CHECKERS = "@@checkers/COMPLETE";
export const LOAD_CHECKERS_IMAGE = "@@checkers/LOAD_CHECKERS_IMAGE";
export const LOADING_WORKFLOW_STEPS = "@@checkers/LOADING_WORKFLOW_STEPS";
export const TOTAL_WORKFLOW_STEPS = "@@checkers/TOTAL_WORKFLOW_STEPS";
